import { ServerProduct } from '@/lib/janitsjar/Product';
import Variant from '@/cataloguePages/productPageWithVariants/components/Variant';

type VariantsProps = {
  product: ServerProduct;
  currentStoreStock?: number;
  currentStoreStockText?: string;
};

export default function Variants({
  product,
  currentStoreStockText,
  currentStoreStock,
}: VariantsProps) {
  if (!product.variants) return null;

  return (
    <div className="flex flex-col gap-6">
      {product.variants.attributes.map((attribute) => (
        <Variant
          key={attribute.code}
          attribute={attribute}
          product={product}
          type={attribute.code === 'colour' ? 'image' : 'text'}
          currentStoreStock={currentStoreStock}
          currentStoreStockText={currentStoreStockText}
        />
      ))}
    </div>
  );
}
